
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic12Off as ObiHydraulic12OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-12-off.js';
 
 
 

 
 export const ObiHydraulic12Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-12-off',
   elementClass: ObiHydraulic12OffElement,
   events: {
     
   }
  });
 
 